var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:[
    _vm.$style.header,
  ]},[_c('div',{class:_vm.$style.content},[_c('div',{class:_vm.$style.left},[_vm._t("left")],2),(_vm.$slots.center)?_c('div',{class:_vm.$style.center},[_vm._t("center")],2):_vm._e(),_c('div',{class:_vm.$style.right},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }